var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"content",attrs:{"role":"main"}},[_c('div',{staticClass:"content__wrapper"},[_c('content-heading',[_vm._v("Calculator")]),_c('switch-tab',[_c('switch-tab-panel',{attrs:{"label":"Grid"}},[_c('calculator-grid')],1),_c('switch-tab-panel',{attrs:{"label":"Golden"}},[_c('calculator-golden')],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04377dca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/calculator/index.vue
// module id = null
// module chunks = 